




























































































































































import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { post, get } from '@/fn/ajax'
import { alert, success } from '@/util/modal'
import conFirm from './../../views/admin/confirm.vue'
import { courseItem, resourceItem } from '@/api/res'
import { Tooltip, Modal, message } from 'ant-design-vue'
import { getDeviceList, fetchClassList, switchMode, syncPlayTime } from './data'

@Component({
  components: {
    Modal,
    conFirm
  }
})
export default class PlayDeviceList extends ViewBase {
  @Prop({ type: Boolean, default: false }) choseClient!: boolean
  @Prop({ type: Boolean, default: false }) shutDown!: boolean
  lang: any = {}
  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  classId: any = ''

  doc: any

  data: any = []

  classList: any = []

  shutdownVisible: boolean = false

  refresh: boolean = false

  itemsIcon: any = {}

  clearClientVisible: boolean = false

  clearClientId: any = ''

  rowSelection: any = {
    selectedRowKeys: [],
    // 设置设备选中
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      this.rowSelection.selectedRowKeys = selectedRowKeys
      this.$store.commit('setSelectedDeviceIds', selectedRowKeys)
    },
    // 设置不可选中
    getCheckboxProps: (record: any) => ({
      props: {
        key: record.id,
        disabled: record.is_online != '1' ? true : false // Column configuration not to be checked
      }
    })
  }
  rowClassName(record: any, index: number) {
    return 'test' + record.id
  }
  // 默认选中项
  setAutoSelect(list: any) {
    this.rowSelection.selectedRowKeys = list
    this.$store.commit('setSelectedDeviceIds', list)
  }
  // 切换班级
  // onClassChange(value: any) {
  //   localStorage.oldClassId = this.classId
  //   this.$store.commit('setClassId', value)
  //   this.classId = value
  //   localStorage.classId = value || ''
  //   this.fetchDevice()
  // }
  fetchDevice() {
    // 对比新老数据，有新加入设备自动选中
    this.refresh = false
    const oldOnline: any = this.data
      .filter((it: any) => it.is_online == 1)
      .map((it: any) => it.id)
    getDeviceList().then(res => {
      const { data } = res
      this.data = data.list
      this.$store.commit('setDeviceList', this.data)
      const newOnline: any = this.data
        .filter((it: any) => it.is_online == 1)
        .map((it: any) => it.id)
      if (newOnline.length > 0) {
        this.$store.commit('setNoOnline', false)
      } else {
        this.$store.commit('setNoOnline', true)
      }
      // 将当前新增的设备加入到选中中，新加入设备自动选中
      if (oldOnline) {
        let arr: any = [...newOnline, ...oldOnline]
        arr = Array.from(new Set(arr))
        const newArrList = [
          ...arr.filter((_: any) => !newOnline.includes(_)),
          ...arr.filter((_: any) => !oldOnline.includes(_))
        ]
        newArrList.forEach(item => {
          this.rowSelection.selectedRowKeys.push(item)
        })
        this.setAutoSelect(this.rowSelection.selectedRowKeys)
      } else {
        this.setAutoSelect(newOnline)
      }
      let viewClass: any = {}
      const classId = this.classId
      // 读取设备播放的课件id，查找预览图
      if (classId) {
        viewClass = JSON.parse(localStorage['viewClass' + classId] || null)
      } else {
        viewClass = JSON.parse(localStorage.viewClass || null)
      }
      if (viewClass) {
        this.data.forEach((element: any) => {
          element.play_class_id = ''
          if (viewClass[element.id]) {
            element.play_class_id = viewClass[element.id]
          }
        })
      }
      this.fetchItemIds(this.data)
      this.refresh = true
    })
  }
  resetClassId() {
    localStorage.classId = ''
    localStorage.oldClassId = ''
  }
  getClassList() {
    fetchClassList().then(res => {
      this.$store.state.classList = res
      this.classList = res
    })
  }
  async fetchItem(id: any) {
    const { data } = await get(`/api/res/item?id=${id}`)
    const item = data.item || {}
    // console.log(item)
    this.itemsIcon[id.toString()] = item.icon
  }

  async clearClient() {
    const params: any = {
      client_id: this.clearClientId
    }
    this.clearClientVisible = false
    const { data, msg } = await post(`/api/play/clearClientBinding`, params)
    success(msg)
  }

  clearClientClick(id: any) {
    this.clearClientId = id
    this.clearClientVisible = true
  }

  fetchItemIds(list: any) {
    list.forEach((el: any) => {
      if (el.play_class_id && el.play_class_id != '') {
        if (!this.itemsIcon.hasOwnProperty(el.play_class_id)) {
          this.itemsIcon[el.play_class_id] = ''
          this.fetchItem(el.play_class_id)
        }
      }
    })
  }
  getFree() {
    const selectDeviceIds = this.rowSelection.selectedRowKeys
    const list = this.data.filter((it: any) => selectDeviceIds.includes(it.id))
    const someFree = list.length > 0 ? list.some((it: any) => it.cmdMode != 1) : true
    return someFree
  }
  getMute() {
    const selectedDeviceIds = this.rowSelection.selectedRowKeys
    const deviceList = this.data
    const list = deviceList.filter((it: any) => selectedDeviceIds.includes(it.id))
    const someMute = list.length > 0 ? list.every((it: any) => it.is_mute == 1) : false
    return someMute
  }
  checkDeviceIds() {
    const ids = this.rowSelection.selectedRowKeys || []
    const isNoOnline = this.$store.state.noOnline
    if (ids.length == 0) {
      throw isNoOnline
        ? this.i18n.playCtro.noDeviceOnline
        : this.i18n.playCtro.pleaseSelectDevice
    }
    return ids
  }
  async switchMute(ids: any, mute: any) {
    const volume = mute ? 70 : 0
    const pdata = { ids, volume }
    await post('/api/play/set_volume', pdata)
  }
  // 控制
  async modeClick() {
    try {
      const ids = this.checkDeviceIds()
      const free = this.getFree()
      await switchMode(ids, free)
      this.fetchDevice()
      message.success(
        free
          ? this.i18n.playCtro.switchedToControlMode
          : this.i18n.playCtro.switchedToFreeMode
      )
    } catch (ex) {
      message.error(String(ex))
    }
  }
  // 静音
  async muteClick() {
    try {
      const mute = this.getMute()
      const ids = this.checkDeviceIds()
      await this.switchMute(ids, mute)
      message.success(mute ? this.i18n.playCtro.voiceOn : this.i18n.playCtro.muted)
    } catch (ex) {
      message.error(String(ex))
    }
  }
  // 同步画面
  async syncFrameClick() {
    try {
      const status = this.$store.state.playStatus
      const id = this.$store.state.classId
      const ids = this.checkDeviceIds()
      const playIsPause = status == 'Play'
      await syncPlayTime(ids, id, playIsPause)
      message.success(this.i18n.playCtro.syncSuccess)
    } catch (ex) {
      message.error(String(ex))
    }
  }
  // 关机
  shutdownConfirm() {
    try {
      this.checkDeviceIds()
      this.shutdownVisible = true
    } catch (ex) {
      message.error(String(ex))
    }
  }
  shutdownOk() {
    this.shutdownVisible = false
    this.shutdownClick()
  }

  shutdownCancel() {
    this.shutdownVisible = false
  }
  clearClientCancel() {
    this.clearClientVisible = false
  }

  async shutdownClick() {
    try {
      const ids = this.checkDeviceIds()
      await this.shutdown(ids)
      if (this.shutDown) {
        this.$emit('shutDowned')
      }
      localStorage['viewClass' + this.classId] = ''
      this.$store.commit('setPlayId', '')
      this.$store.commit('setPlayInfo', null)
      message.success(this.i18n.playCtro.shutdownSuccess)
    } catch (ex) {
      message.error(String(ex))
    }
  }

  async shutdown(ids: any) {
    const pdata = { ids }
    await post('/api/play/shutdown_json', pdata)
    this.fetchDevice()
  }

  created() {
    this.classId = localStorage.getItem('classId')
    this.resetClassId()
    // this.getClassList()
    // this.fetchDevice()
    // ant自带select下拉选项错位bug
    this.doc = window.document
  }

  @Watch('choseClient')
  watchChoseClient(choseClient: boolean) {
    if (choseClient) {
      this.fetchDevice()
    }
  }

  @Watch('shutDown')
  watchShutDown(shutDown: boolean) {
    if (shutDown) {
      this.shutdownClick()
    }
  }

  @Watch('refresh')
  watchRefresh(refresh: boolean) {
    if (refresh) {
      setTimeout(() => {
        this.fetchDevice()
      }, 3000)
    }
  }
}
